import { CookieParamParamBinder } from "./ParamBinders/CookieParamParamBinder";
import { IParamBinder } from "./ParamBinders/IParamBinder";
import { JsonBodyParamBinder } from "./ParamBinders/JsonBodyParamBinder";
import { StringBodyParamBinder } from "./ParamBinders/StringBodyParamBinder";
import { IValueParser, UrlParamBinder } from "./ParamBinders/UrlParamBinder";
import { UrlQueryParamBinder } from "./ParamBinders/UrlQueryParamBinder";

export const httpType = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-argument
    Number: (x: any) => (x == undefined ? undefined : parseInt(x, 10)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    String: (x: any) => (x == undefined ? undefined : `${x}`),
};

export function httpUrlParam(urlParamName: string, valueParser: IValueParser): IParamBinder {
    return new UrlParamBinder(urlParamName, valueParser);
}

export function httpQueryParam(urlParamName: string, valueParser: IValueParser): IParamBinder {
    return new UrlQueryParamBinder(urlParamName, valueParser);
}

export function httpJsonBodyParam(): IParamBinder {
    return new JsonBodyParamBinder();
}

export function httpRawBodyParam(): IParamBinder {
    return new JsonBodyParamBinder();
}

export function httpStringBodyParam(): IParamBinder {
    return new StringBodyParamBinder();
}

export function httpCookieParam(key: string): IParamBinder {
    return new CookieParamParamBinder(key);
}

export function httpBindParam(paramBinder: IParamBinder): IParamBinder {
    return paramBinder;
}
